import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, of } from 'rxjs';
import { CatalogueService } from './components/catalogue/catalogue.service';
import { DetailsService } from './components/details/details.service';
import { EventType } from '../environments/common';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { SharedService } from './services/shared.service';
import { AnalyticsService } from './components/analytics/analytics.service';
import { UtilsService } from './components/utils/utils.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  event: string;
  filter: string;
  lang: string;
  selectedSectors: string[];
  selectedCountries: string[];
  selectedHomeOds: string[];
  tab: string;

  title = 'Ecatalogue frontoffice';

  constructor(
    public translate: TranslateService, private catalogueService: CatalogueService, private detailsService: DetailsService, private route: ActivatedRoute, private router: Router, private sharedService: SharedService, private utilsService: UtilsService
  ) {
    this.translate.addLangs(['es', 'en', 'ca']);
    this.translate.setDefaultLang('es');
    this.translate.use('es');
  }

  /**
   * [setCustomStyles: Aplica los estilos dinámicos de colores]
   */
  setCustomStyles():void {    
    const code = `body {background-color: ${this.catalogueService.getProperty('pageColor')} !important;}
        .enforcedAppColor {color: ${this.catalogueService.getProperty('mainColor')} !important;}
        .appColor {color: ${this.catalogueService.getProperty('mainColor')} !important;}
        .appColorOnHover:hover {color: ${this.catalogueService.getProperty('mainColor')} !important;}
        .langColor {color: ${this.catalogueService.getProperty('languageColor')};}
        .appColorBackground {background-color: ${this.catalogueService.getProperty('mainColor')};}
        .page-item.active .page-link{background: ${this.catalogueService.getProperty('mainColor')}; border-color: ${this.catalogueService.getProperty('mainColor')} !important; color: ${this.catalogueService.getProperty('languageColor')} !important; }
        .page-item .page-link{border-color: ${this.catalogueService.getProperty('mainColor')} !important; color: ${this.catalogueService.getProperty('mainColor')} !important; }
        .page-item .page-link:focus{ box-shadow: none }
        .mainScrollBar .ng-scrollbar .ng-scrollbar-thumb {background-color: ${this.catalogueService.getProperty('mainColor')} !important;}
        .appFeaturedColor::before {border-top-color: ${this.catalogueService.getProperty('featuredColor')} !important; border-bottom-color: ${this.catalogueService.getProperty('featuredColor')} !important;}`;
    const styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = code;
    document.getElementsByTagName("head")[0].appendChild(styleElement);
  }


  ngOnInit(): void {

    this.route.params.subscribe(params => {
      this.event = params['event'];
      this.selectedSectors = params['sectors'] ? params['sectors'].split(',') : [];
      this.selectedCountries = params['countries'] ? params['countries'].split(',') : [];
      this.selectedHomeOds = params['ods'] ? params['ods'].split(',') : [];
    });

    this.route.queryParams.subscribe(params => {
      this.lang = params['lang'];
      this.tab = params['tab'];
      
      // Si hay un parámetro lang en la URL, usarlo inmediatamente
      if (this.lang) {
        const shortLang = this.utilsService.getLanguageShortISO(this.lang);
        if (this.utilsService.isValidLanguage(shortLang)) {
          this.translate.use(shortLang);
        }
      }
    });

    this.route.data.subscribe(data => {
      this.filter = data['filter'];
    });

    /** Aplica los estilos cuando los colores están configurados */
    this.router.events.subscribe( (val) => {
      if (val instanceof NavigationEnd) {
        this.setCustomStyles();
      }
    });

    /** Aplica los estilos cuando se actualizan los detalles */
    this.detailsService.getIsUpdateDetails().subscribe(update => {
      if (update) {
        this.setCustomStyles();
      }
    });

  }

}
